module.exports = "/_next/static/images/teacher-5-3212dcfc4cd044baadd799d23d9dcd0c.png";